import { Router } from 'vue-router';
import { defineStore } from 'pinia';
import { RouterState } from './types';

const useRouterStore = defineStore('router', {
  state: (): RouterState => ({
    // 由于useRouter使用受限以及在如request.ts等文件中直接导入router会导致cycle，所以在provider中借机保存了一份router方便使用
    globalRouter: undefined,
  }),

  getters: {},

  actions: {
    // Set user's information
    setInfo(partial: Partial<RouterState>) {
      this.$patch(partial);
    },
    // Reset user's information
    resetInfo() {
      this.$reset();
      this.setRouter();
    },
    setRouter(router?: Router) {
      this.globalRouter = router;
    },
  },
});

export default useRouterStore;
